export const getDataFromLocalStorage = (clientId, username, data) => {
  return localStorage.getItem(
    `CognitoIdentityServiceProvider.${clientId}.${username}.${data}`
  );
};
